export default "__VITE_ASSET__58c355c4__"